import { render, staticRenderFns } from "./Resignup.vue?vue&type=template&id=6900a4e3&scoped=true&"
import script from "./Resignup.vue?vue&type=script&lang=js&"
export * from "./Resignup.vue?vue&type=script&lang=js&"
import style0 from "./Resignup.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Resignup.vue?vue&type=style&index=1&id=6900a4e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6900a4e3",
  null
  
)

export default component.exports